export default "__VITE_ASSET__K1kwRhFe__"